import styled from "styled-components";

const MyDiv = styled.div`
@keyframes blinkRed {
  0%,100% { color:#B42318; }
  50% { color:#F04438; }
}

@keyframes blinkOrange {
  0%,100% { color:#C4320A; }
  50% { color:#F79009; }
}

.blink-red {
  animation: blinkRed 1s infinite;
}

.blink-orange {
  animation: blinkOrange 1s infinite;
}
`;

export default MyDiv;